<template>
  <div class="card">    
    <div class="card-body ">
      <div class="row">
        <div class="col-8">
          <div>
            <el-form  :model="filter" @submit.prevent="getPartnerSummaryList" >
              <div class="row">
                <div class="col-4">
                  <el-input
                    v-model="filter.search" 
                    placeholder="ค้นหา"
                    clearable 
                    :prefix-icon="searchIcon"
                  />                 
                </div>                
                <el-button hidden native-type="submit" icon="el-icon-search"></el-button>
                <div class="col-4">
                  <date-time-picker-with-option style="max-width: 250px"  v-model="filter.dateRange" @change="getPartnerSummaryList"></date-time-picker-with-option>
                </div>                
              </div>
            </el-form>
          </div>
        </div>        
      </div>

      <div class="mt-3">
        <el-table
          :data="partnerSummaryList"    
          @row-dblclick="onPartnerSummaryRowDoubleClickHandler"
          :height="windowHeight - 240"
          highlight-current-row
          show-summary
          :summary-method="summary"
        >
          <el-table-column label="รหัส" prop="partnerCode" width="120"></el-table-column>
          <el-table-column label="ชื่อ" prop="partnerName" width="140"></el-table-column>
          <el-table-column
            label="คงเหลือ(ตัน)"
            prop="stockWeightTon"
            align="right"
            sortable>
            <template #default="scope">
              {{ numberWithCommas(scope.row.stockWeightTon, 2) }} 
            </template>
          </el-table-column>        
          <el-table-column
            label="คงเหลือ(บาท)"
            prop="stockPrice"
            align="right"
            sortable>
            <template #default="scope">
              {{ numberWithCommas(scope.row.stockPrice, 2) }} 
            </template>
          </el-table-column>    
          <el-table-column
            label="ค้างนาน(ตัน)"
            prop="longStockWeightTon"
            align="right"
            sortable>
            <template #default="scope">
              {{ numberWithCommas(scope.row.longStockWeightTon, 2) }} 
            </template>
          </el-table-column>         
          <el-table-column
            label="จน.ออเดอร์"
            prop="orderCount"
            align="right"
            sortable>
            <template #default="scope">
              {{ numberWithCommas(scope.row.orderCount, 0) }} 
            </template>
          </el-table-column>
          <el-table-column
            label="ยอดขาย(ตัน)"
            prop="totalWeight"
            align="right"
            sortable>
            <template #default="scope">
              {{ numberWithCommas(scope.row.totalWeight, 2) }} 
            </template>
          </el-table-column>
          <!-- จำนวนเงิน -->
          <el-table-column
            label="ยอดขาย(บาท)"
            prop="totalSales"
            align="right"
            sortable>
            <template #default="scope">
              {{ numberWithCommas(scope.row.totalSales, 2) }} 
            </template>
          </el-table-column>          
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>

import { defineComponent, onMounted, reactive, ref } from "vue";
import { setCurrentPageTitle, setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from '../../../core/services/ApiService';
import { numberWithCommas, formatDateFromISO, formatDateThDate } from "@/utils";
import DateTimePickerWithOption from '../../../components/forms/DateTimePickerWithOption.vue';
import { DateTime } from 'luxon'

export default {
  components: {
    DateTimePickerWithOption
  },
  data() {
    return {
      filter: {
        search: null,
        dateRange: []
      },
      windowHeight: window.innerHeight,
      partnerSummaryList: []
    }
  },
  created() {
    var date = new Date(), y = date.getFullYear(), m = date.getMonth();
    this.filter.dateRange[0] = new Date(y, m, 1)
    this.filter.dateRange[1] = new Date(y, m + 1, 0)
  },
  mounted() {
    setCurrentPageBreadcrumbs("รายงานการขายพาร์ทเนอร์", ["รายงาน"])
    // setCurrentPageTitle("รายงานการขาย");
    this.getPartnerSummaryList();
  },
  methods: {
    numberWithCommas,
    getPartnerSummaryList: async function() {
      
      const params = {}
    // console.log(this.filter)
      if(this.filter.dateRange[0])
      {
        params.startDate = DateTime.fromJSDate (this.filter.dateRange[0]).toFormat('yyyy-MM-dd')
      }
      if(this.filter.dateRange[1])
      {
        params.endDate = DateTime.fromJSDate (this.filter.dateRange[1]).toFormat('yyyy-MM-dd')
      }
      if(this.filter.search && this.filter.search.trim() != "")
      {
        params.search = this.filter.search.trim()
      }

      const { data } = await ApiService.query("orders/partner-summary", {params})
      this.partnerSummaryList = data
    },
    onPartnerSummaryRowDoubleClickHandler(row) {
      this.$router.push({
        name: "orderList", 
        params: { basePartnerCode: row.partnerCode },
        query: {
          startDate: DateTime.fromJSDate (this.filter.dateRange[0]).toFormat('yyyy-MM-dd'),
          endDate: DateTime.fromJSDate (this.filter.dateRange[1]).toFormat('yyyy-MM-dd')
        }
      })
    },
    summary({columns, data}) {
      const sums = [];
      columns.forEach((col, index) => {
        if(index === 0) {
          sums[index] = data.length + ' รายการ';
        }

        const sumColumns = ['orderCount', 'totalSales', 'totalWeight', 'stockWeightTon','longStockWeightTon','stockPrice']
        if(sumColumns.includes(col.property)) {
          sums[index] = numberWithCommas(data.reduce(
            (prev, curr) => {
              return prev + curr[col.property]
            },
            0
          ), (col.property == 'orderCount' ? 0 : 2) )
        }
      })      
      return sums;
    },
  }
}
</script>